"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CardList;

var _react = _interopRequireDefault(require("react"));

var _Row = _interopRequireDefault(require("@components/Layout/Row"));

var _Col = _interopRequireDefault(require("@components/Layout/Col"));

var _Pagination = _interopRequireDefault(require("@components/Pagination"));

var _Button = _interopRequireDefault(require("@components/Button"));

var _Card = _interopRequireDefault(require("@components/Cards/Card"));

var _scss = require("@scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CardList(_ref) {
  var titleCardsTag = _ref.titleCardsTag,
      cardColumns = _ref.cardColumns,
      cards = _ref.cards,
      cardMb = _ref.cardMb,
      classes = _ref.classes,
      pagination = _ref.pagination,
      cta = _ref.cta;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: (0, _scss.cls)(classes === null || classes === void 0 ? void 0 : classes.wrapper)
  }, cards && cards.map(function (card, index) {
    return /*#__PURE__*/_react["default"].createElement(_Col["default"], {
      key: "cardlist-".concat(index),
      col: cardColumns,
      mb: cardMb,
      className: (0, _scss.cls)(classes === null || classes === void 0 ? void 0 : classes.col)
    }, /*#__PURE__*/_react["default"].createElement(_Card["default"], _extends({
      titleComponent: titleCardsTag
    }, card)));
  })), pagination !== null && pagination !== void 0 && pagination.pages && pagination.pages > 1 ? /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], null, /*#__PURE__*/_react["default"].createElement(_Pagination["default"], pagination))) : null, cta && /*#__PURE__*/_react["default"].createElement(_Button["default"], cta));
}